export function formatList(list) {
    const options = list.map((v) => ({ value: `${v.id}`, label: v.name }));
    options.sort((a, b) => (a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1));
    return options;
}
